import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from "@material-ui/core";
import React from "react";

import i18n from "../../services/localization/i18n";

interface IConsentDialogProps {
    open: boolean;
    title: string;
    description: string;
    onAccept: () => void;
    onCancel: () => void;
}

interface IConsentDialogState {
    open: boolean;
}

class ConsentDialog extends React.Component<IConsentDialogProps, IConsentDialogState> {

    /**
     * Creates an instance of Consent.
     * @param {IConsentProps} props
     * @memberof Consent
     */
    constructor(props: IConsentDialogProps) {
        super(props);

        this.state = {
            open: props.open,
        };
    }

    public render()  {

        const {title, description} = this.props;

        return <Dialog  open = {this.state.open}
                        onClose = {this.onCancel}
                        aria-labelledby= "alert-dialog-title"
                        aria-describedby= "alert-dialog-description">
            <DialogTitle id="alert-dialog-title">{title}</DialogTitle>
            <DialogContent>
                <DialogContentText id="alert-dialog-description">
                    { description }
                </DialogContentText>
            </DialogContent>
            <DialogActions>
            <Button onClick={this.onCancel} variant="text" autoFocus={true}>
                { i18n.t("consentdialog_button_cancel") }
            </Button>
            <Button onClick={this.onAccept} variant="text">
            { i18n.t("consentdialog_button_ok") }
            </Button>
            </DialogActions>
        </Dialog >;
    }

    private onAccept = () => {
        this.props.onAccept();
        this.onClosed();
    }

    private onCancel = () => {
        this.props.onCancel();
        this.onClosed();
    }

    private onClosed = () => {
        this.setState({
            open: false,
        });
    }

}

export default ConsentDialog;
